import React from "react";
import { Box, Button, Chip, Link as MuiLink, Stack, Typography } from "@mui/material";
import Separator from "../assets/Separator.svg";
import NewsLetterSub from "../assets/NewsLetterSub.svg";
import ArticleIcon from "@mui/icons-material/Article";
import { Text } from "./NewsLetterComp";
import BlogCard from "./BlogCard";
import { blogPosts } from "../data/blogPosts";

const NEWSLETTER_URL =
  "https://57927b91.sibforms.com/serve/MUIFACjnqNUefDpSiojhOuNkkIEbfsBJK-hG9jGMpZHvtBYbVY5b8Y6qIfrLFrvm9mD6dnZ_m4zGq-u9bjCwMvuQHfxqEGm3F0qLLsMeL5aT2uu5BFlIkSRmG5zwGE6Z-zb_XN9iS-btTBYdT8agLzZXOYF8r4k0_-fPSZNee3flMfpiPB81jZvyv0fkTGsJgBzlgDPt7FCd2k9b";

const topics = ["AI Safety", "Product Updates", "Research", "Industry Notes"];

const BlogComp = () => {
  const [featuredPost, ...restPosts] = blogPosts;

  return (
    <Box sx={{ px: 3, py: { lg: 3 }, position: "relative", zIndex: 1 }}>
      <Stack
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        sx={{ pt: { xs: 4, sm: 2 }, pb: 2 }}
      >
        <Typography
          sx={{
            fontFamily: "Righteous",
            fontWeight: 400,
            fontSize: { xs: "28px", sm: "36px" },
            backgroundImage:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.4) 100%)",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          The Veracious Blog
        </Typography>
        <Text
          sx={{
            fontWeight: 400,
            fontSize: { xs: "15px", sm: "14px" },
            color: "#C2C2C2",
            maxWidth: "560px",
            mt: 1.5,
          }}
        >
          Insights, deep dives, and updates from the Veracious team on AI,
          our products, and the future of technology.
        </Text>

        <Box sx={{ pt: { xs: 2, sm: 1 }, width: "100%", display: "flex", justifyContent: "center" }}>
          <img width="100%" src={Separator} alt="" />
        </Box>
      </Stack>

      {blogPosts.length === 0 ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          spacing={2.5}
          sx={{
            py: { xs: 6, sm: 8 },
            px: 3,
            mx: "auto",
            maxWidth: "480px",
          }}
        >
          <ArticleIcon sx={{ fontSize: "42px", color: "#9FA2AC" }} />
          <Typography
            sx={{
              fontFamily: "Righteous",
              fontWeight: 400,
              fontSize: "18px",
              color: "#FFFFFF",
            }}
          >
            Our first story is on its way
          </Typography>
          <Text sx={{ fontWeight: 400, fontSize: "14px", color: "#9FA2AC" }}>
            Subscribe to our newsletter so you don't miss it when it drops.
          </Text>
        </Stack>
      ) : (
        <Box sx={{ py: { xs: 3, sm: 4 }, maxWidth: "1100px", mx: "auto" }}>
          {featuredPost && (
            <Box sx={{ mb: 4 }}>
              <BlogCard {...featuredPost} featured />
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 4,
            }}
          >
            {restPosts.map((post) => (
              <BlogCard key={post.id} {...post} />
            ))}
          </Box>
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "center", pt: { xs: 2, sm: 3 } }}>
        <img width="100%" src={Separator} alt="" />
      </Box>

      <Stack
        alignItems="center"
        textAlign="center"
        spacing={2.5}
        sx={{ py: { xs: 5, sm: 7 }, px: 3, mx: "auto", maxWidth: "620px" }}
      >
        <Typography
          sx={{
            fontFamily: "Righteous",
            fontWeight: 400,
            fontSize: { xs: "22px", sm: "26px" },
            backgroundImage:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.4) 100%)",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Why we write this
        </Typography>

        <Text sx={{ fontWeight: 400, fontSize: "14px", lineHeight: 1.8, color: "#B7BAC7" }}>
          The Veracious blog is where we think out loud about the systems we're
          building and the industry we're building them in — essays on AI
          safety and agent behaviour, deep dives on the products we ship, and
          field notes from a team shipping AI tools every week. No recycled
          press releases, just what we're actually seeing and thinking.
        </Text>

        <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1}>
          {topics.map((topic) => (
            <Chip
              key={topic}
              label={topic}
              size="small"
              sx={{
                background: "#FFFFFF14",
                color: "#1ACBAF",
                fontFamily: "Raleway",
                fontWeight: 600,
                fontSize: "11px",
              }}
            />
          ))}
        </Stack>

        <MuiLink href={NEWSLETTER_URL} target="_blank" underline="none">
          <Button
            variant="contained"
            sx={{
              background: "#21426B !important",
              textTransform: "none",
              px: "16px",
              py: "8px",
              borderRadius: "6px",
              boxShadow: "0px 40px 40px 0px #00000040",
              "&:hover": { background: "#2e507f !important" },
            }}
          >
            <img style={{ marginRight: "16px" }} src={NewsLetterSub} alt="" />
            <Text
              sx={{
                fontSize: "14px",
                backgroundImage:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.3) 100%)",
                backgroundClip: "text",
              }}
            >
              Subscribe to our Newsletter
            </Text>
          </Button>
        </MuiLink>
      </Stack>
    </Box>
  );
};

export default BlogComp;
